<template>
  <div :class="containerClass">
    <canvas ref="chart" :height="height"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import { doughnutChartOptions } from "./config";
import { centerTextPlugin } from "./utils";

export default {
  props: {
    data: {
      type: Object
    },
    containerClass: {
      type: String,
      default: "chart-container"
    },
    shadow: {
      type: Boolean,
      default: false
    },
    legendPosition: {
      type: String,
      default: "right"
    },
    legendAlignment: {
      type: String,
      default: "start"
    },
    height: {
      type: Number,
      default: 150
    },
    options: {
      legend: {
        position: "right",
        align: "start",
        fullWidth: false,
        labels: {
          fontSize: 10,
          boxWidth: 5,
          fontColor: "#666"
        }
      }
    },
    activity: Number
  },
  data() {
    return {
      doughnutData: this.data,
      countActivity: this.activity
    };
  },
  watch: {
    data() {
      this.doughnutData = this.data;
      this.renderChart();
    }
  },
  methods: {
    renderChart() {
      let chart = null;
      if (this.shadow) {
        Chart.defaults.doughnutWithShadow = Chart.defaults.doughnut;
        Chart.controllers.doughnutWithShadow = Chart.controllers.doughnut.extend({
          draw(ease) {
            Chart.controllers.doughnut.prototype.draw.call(this, ease);
            const chartCtx = this.chart.chart.ctx;
            chartCtx.save();
            chartCtx.shadowColor = "rgba(0,0,0,0.15)";
            chartCtx.shadowBlur = 10;
            chartCtx.shadowOffsetX = 0;
            chartCtx.shadowOffsetY = 10;
            chartCtx.responsive = true;
            Chart.controllers.doughnut.prototype.draw.apply(this, arguments);
            chartCtx.restore();
          }
        });
      }
      const ctx = this.$refs.chart;

      if (chart) {
        chart.destroy();
      }

      chart = new Chart(ctx, {
        type: this.shadow ? "doughnutWithShadow" : "doughnut",
        data: this.doughnutData,
        options: {
          ...doughnutChartOptions,
          legend: {
            ...doughnutChartOptions.legend,
            position: this.options ? this.options.legend.position : this.legendPosition,
            align: this.options ? this.options.legend.align : this.legendAlignment,
            fullWidth: false,
            labels: {
              ...doughnutChartOptions.legend.labels,
              fontSize: this.options.legend.labels.fontSize,
              boxWidth: this.options.legend.labels.boxWidth,
              fontColor: this.options.legend.labels.fontColor
            }
          },
          events: [this.options.events]
        },
        plugins: [centerTextPlugin]
      });
      if (this.doughnutData.datasets[0].data[0] == 0 && this.countActivity < 1) {
        Chart.pluginService.register({
          beforeDraw: function(chart) {
            const width = chart.chart.width;

            const height = chart.chart.height;

            const ctx = chart.chart.ctx;
            ctx.restore();
            const fontSize = (height / 300).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            const text = "No activities for today";

            const textX = Math.round((width - ctx.measureText(text).width) / 2);

            const textY = height / 2;
            ctx.fillText(text, textX, textY);
            ctx.save();
          }
        });
      }
    }
  },
  mounted() {
    this.renderChart();
  }
};
</script>
